import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-compliance-badge',
  standalone: true,
  templateUrl: './compliance-badge.component.html',
  styleUrls: ['./compliance-badge.component.scss'],
})
export class ComplianceBadgeComponent {
  @Input() label = '—';
  @Input() tone: 'red' | 'amber' | 'clear' = 'clear';
}
